<template>
  <Box
    variant="alt-light"
    class="directory__box"
    :class="{ 'directory--selected': selected }"
    @click.native="selectDirectory()"
  >
    <Media align="middle">
      <MediaBody class="directory__details mrgr0">
        <div class="directory__title">
          {{
            directory.is_global
              ? $t('directories.directory.global-directory')
              : directory.name
          }}
        </div>
        <div class="text-small">
          {{ directory.entries.length }}
          {{ $t('directories.directory.contacts') }}
        </div>
      </MediaBody>

      <MediaRight v-if="!directory.is_global" class="directory__actions">
        <Btn variant="danger" small @click="toggleDirectoryDelete">
          {{ $t('common.delete') }}
        </Btn>
      </MediaRight>
    </Media>
  </Box>
</template>

<script>
import eventBus from '@/eventBus';

export default {
  props: {
    directory: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    selectDirectory() {
      this.$emit('select', this.directory.id);
    },

    toggleDirectoryDelete() {
      eventBus.$emit('toggleDirectoryDelete', this.directory);
    },
  },
};
</script>

<style lang="scss" scoped>
.directory__details {
  max-width: 250px;
}

.directory__title {
  font-weight: bold;
}

.directory--selected {
  background-color: $brand-400;
}

.directory__box {
  cursor: pointer;

  :hover > &:not(.directory--selected),
  :focus-within > &:not(.directory--selected) {
    background-color: $brand-100;
  }
}

.directory__actions {
  .btn {
    opacity: 0;
    transition: opacity 0.15s ease;

    .directory__box:hover & {
      opacity: 1;
    }
  }
}
</style>
